import React from "react";
import ProductTile from "../../product-category/components/ProductTile";

const SearchResults = (props) => {
  return (
    <div className="related-products__grid related-products__grid--search">
      {props.products.map((product) => (
        <ProductTile key={`product_${product.id}`} product={product} />
      ))}
    </div>
  );
};

export default SearchResults;
